import React from 'react'

const SvgCalendarCheckOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 2c.667 0 1 .314 1 .941V4h1c1.333 0 2 .667 2 2v6.919l-2 2.027V10H6v10h3.234c.141.334.345.647.614.92L10.913 22H6c-1.333 0-2-.667-2-2V6.004C4 4.668 4.667 4 6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941zM6 8h12V6H6v2z'
    />
    <path d='M10 16c.288 0 .513.062.677.186-.3.142-.582.335-.83.585-.35.356-.59.78-.724 1.229H9c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10zM15 16c.659 0 .99.325.999.975l-.929.942-1.13-1.146a2.895 2.895 0 00-.692-.519c.167-.169.419-.252.754-.252H15zM10 12c.667 0 1 .333 1 1s-.333 1-1 1H9c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H10zM15 12c.667 0 1 .333 1 1s-.333 1-1 1h-1c-.667.001-1-.332-1-1 0-.668.335-1.001 1.002-1H15z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.72 14.284a.98.98 0 010 1.37l-6.953 7.062a.943.943 0 01-1.348 0l-3.14-3.189a.98.98 0 010-1.37.943.943 0 011.349 0l2.465 2.505 6.28-6.378a.943.943 0 011.348 0z'
    />
  </svg>
)

export default SvgCalendarCheckOutline
